import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'lib-resource-library',
  template: ``,
  styles: []
})
export class ResourceLibraryComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
